<form [formGroup]="form" (ngSubmit)="save()">
     <h1 mat-dialog-title>Institución derivante</h1>
   <div mat-dialog-content>
        <mat-form-field class="full-width">
            <input type="text"  matInput placeholder="Nombre" formControlName="Name" required>

            <mat-error *ngIf="f.Name.errors && f.Name.errors.required">
                Escriba un nombre
            </mat-error>
        </mat-form-field>
    </div>
    <div class="clearfix">
        <div class="pull-right">
            <button mat-button type="submit">Guardar</button>
            <button mat-button type="button" cdkFocusInitial (click)="onNoClick()">Cancelar</button>
        </div>
    </div>
</form>
